import React from 'react';
import CalendarView from './CalendarView';
import BottomNav from './BottomNav';
import { getGradeLabel } from '../utils/gradeUtils';

export default function HomeScreen({ stats, stampMap, onStart, onNav, onInfo, onLogout, currentChild, onProfileTap }) {
  const monthProgress = Math.min(100, Math.round((stats.monthDays / 20) * 100));
  const gradeLabel = (currentChild?.birth_year && currentChild?.birth_month)
    ? getGradeLabel(currentChild.birth_year, currentChild.birth_month)
    : '';

  return (
    <div className="home-v9">

      {/* ─── グラデーションヘッダー（固定） ─── */}
      <div className="v9-header" style={{ flexShrink: 0 }}>
        <div className="v9-blob1" />
        <div className="v9-blob2" />
        <button className="v9-info-btn" onClick={onInfo} title="アプリについて">⚙️</button>
        <div className="v9-header-inner">
          <div className="v9-header-top">
            <div>
              <div className="v9-logo-sub">READING APP</div>
              <div className="v9-logo-main">Ondoku <span>Quest</span></div>
            </div>
            <div className="v9-streak-chip">
              <span className="chip-icon">⚡</span>
              <span style={{ fontSize: 17, fontWeight: 900 }}>{stats.streak}</span>にち れんぞく
            </div>
          </div>
          {/* プロフィールチップ */}
          {currentChild && onProfileTap && (
            <button className="home-profile-chip" onClick={onProfileTap}>
              <span className="home-profile-avatar">{currentChild.avatar || '🐣'}</span>
              <span className="home-profile-name">{currentChild.name || 'ゲスト'}</span>
              {gradeLabel && <span className="home-profile-grade">（{gradeLabel}）</span>}
              <span className="home-profile-arrow">▼</span>
            </button>
          )}

          <div className="v9-greeting-msg">
            きょうも<span>よんで</span>みよう！
          </div>
          <div className="v9-progress-box">
            <div className="v9-progress-row">
              <span>こんげつ よんだ</span>
              <span><strong>{stats.monthDays}</strong> にち</span>
            </div>
            <div className="v9-progress-track">
              <div className="v9-progress-fill" style={{ width: `${monthProgress}%` }} />
            </div>
          </div>
        </div>
      </div>

      {/* ─── スクロールエリア ─── */}
      <div className="home-scroll-area">

        {/* カレンダーエリア */}
        <div className="v9-calendar-section">
          <CalendarView stampMap={stampMap} />
        </div>

        {/* スタートボタン */}
        <button className="v9-btn-start" onClick={onStart}>
          <span>📚</span>
          ほんをえらんで　よもう！
        </button>

        {/* ログアウト */}
        {onLogout && (
          <button className="home-logout-btn" onClick={onLogout}>
            ログイン画面にもどる
          </button>
        )}

      </div>

      {/* ─── ボトムナビ（固定） ─── */}
      <BottomNav active="home" onNav={onNav} />

    </div>
  );
}
